var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9295 13.3043L23.9293 13.304L23.9292 13.3043H23.9295Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9292 13.3043C23.9292 13.3042 23.9293 13.3041 23.9293 13.304L10.7693 0.0623779C10.1757 0.122894 9.59475 0.226675 9.02986 0.370534C3.83897 1.69217 0 12 0 12C0 12 16.7999 23.2423 18.7165 21.9452C19.1 21.6857 19.4677 21.4046 19.8177 21.1036L12.0185 13.3043H23.9292Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8695 12L9.19898 0.329498C3.92287 1.59123 0 6.33714 0 12C0 18.6274 5.37262 24 12 24C14.5139 24 16.8467 23.2265 18.7748 21.9052L8.86955 12H20.8695Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4128 17.7184L9.9472 17.0291L10.7276 15.6098L9.13622 15.9142L8.93456 14.3065L7.82611 15.4889L6.71766 14.3065L6.51595 15.9142L4.92459 15.6097L5.70502 17.0291L4.23942 17.7184L5.70502 18.4077L4.92459 19.8271L6.51605 19.5227L6.71761 21.1303L7.82611 19.9479L8.93456 21.1303L9.13622 19.5227L10.7276 19.8271L9.94716 18.4078L11.4128 17.7184Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 6.65545L9.36886 6.15412L9.93647 5.1218L8.77899 5.34323L8.63231 4.17389L7.82611 5.0339L7.01991 4.17389L6.87319 5.34323L5.7157 5.1218L6.28336 6.15412L5.21738 6.65545L7.82611 7.17726L10.4348 6.65545Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 6.65546C10.9565 8.38435 9.55495 9.78591 7.82606 9.78591C6.09717 9.78591 4.69561 8.38435 4.69561 6.65546",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/nepal.92a7f6f7062e8b7870af3001aa1b5c6d.svg";
export { ForwardRef as ReactComponent };